import { Microfrontend } from '@cian/mf-react';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { DESKTOP_FILTERS_MANIFEST_INFO_SETTING_KEY } from 'shared/constants/microfrontends';
import { usePuidsSelector } from 'shared/hooks/usePuidsSelector';
import { selectSource } from 'shared/selectors';
import { getDealType } from 'shared/selectors/getDealType';
import { selectDate } from 'shared/selectors/results/selectDate';
import { selectIsAgent } from 'shared/selectors/user';
import { EDealType } from 'shared/types/dealType';
import { IManifestInfo } from 'shared/types/manifestInfo';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { SaveSearchModalContainer } from '../SaveSearchModalContainer';
import { useFiltersUpdatedEvent, useSaveSearchModal, useToggleFiltersTags } from './hooks';

export const DesktopFiltersMicrofrontend: React.FC = () => {
  const { config, microfrontendsAPI, microfrontendsRegistry } = useApplicationContext();

  const manifestInfo = config.get<IManifestInfo | null>(DESKTOP_FILTERS_MANIFEST_INFO_SETTING_KEY);

  useFiltersUpdatedEvent();
  useToggleFiltersTags();

  const { open, onModalClose, onModalOpen, onSubscribed, subscribeToPush } = useSaveSearchModal();

  const userIsAgent = useSelector(selectIsAgent);
  const source = useSelector(selectSource);
  const dates = useSelector(selectDate);
  const dealType = useSelector(getDealType);

  const adfoxPuids = usePuidsSelector();

  React.useEffect(() => {
    if (
      source === 'search_string' &&
      dealType === EDealType.RentDaily &&
      !dates &&
      microfrontendsRegistry.microfrontend('desktop-filters-micro-frontend') &&
      microfrontendsAPI
    ) {
      microfrontendsAPI.getDesktopFiltersMicrofrontendApi().openDatesPopup();
    }
  }, [dates, dealType, microfrontendsAPI, microfrontendsRegistry, source]);

  return (
    <>
      {manifestInfo && (
        <Microfrontend
          {...manifestInfo}
          parameters={{
            adfoxPuids,
            professionalSearchAvailable: userIsAgent,
          }}
        />
      )}
      <SaveSearchModalContainer
        isOpen={open}
        onSubscribed={onSubscribed}
        onPushSubscribed={subscribeToPush}
        onOpen={onModalOpen}
        onClose={onModalClose}
      />
    </>
  );
};
